import { Box, Grid, Typography } from '@mui/material';
import { KeyValue } from './contributor';
import { SubHeading } from '../investors/components';
import React, { useEffect, useState } from 'react';
import { Gridstyles } from './index';
import { Applicant, BrokerList } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { DLCLMasters, dlclIdFieldValidationDate } from '../../utils/constant';
import {
  checkValidationBasedOnDate,
  getclIdField,
  getdpIdField,
  grossAnnualIncomeNewMaster,
  isCDSL,
  isOccupationTypeOthers,
} from '../../utils/utilityFunctions';
import { getBrokers } from '../../redux-store/actions/application';
import { useDispatch } from 'react-redux';
import TermsAndConditions from '../Declaration/TermsAndConditions';
import ApplicantDeclaration from '../Declaration/ApplicantDeclaration';

export default function KycDetails({
  applicants = [],
  createdAt,
}: {
  applicants: Partial<Applicant>[];
  createdAt: string;
}): JSX.Element {
  const dispatch = useDispatch();
  const [brokerList, setBrokerList] = useState<BrokerList>();
  useEffect(() => {
    (async function () {
      try {
        const response = (await dispatch(getBrokers())) as unknown as BrokerList;
        setBrokerList(response as BrokerList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Typography
              component="h2"
              sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
              Additional KYC Details
            </Typography>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>{title}</SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={15}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue
                        title={'Occupation Details'}
                        description={
                          isOccupationTypeOthers(applicant?.occupationDetails || '')
                            ? applicant.occupationTypeOthers
                            : applicant.occupationDetails
                        }
                      />
                      <KeyValue
                        title={'Gross Annual Income'}
                        description={
                          grossAnnualIncomeNewMaster(createdAt)[
                            applicant.grossAnnualIncome || ''
                          ] || applicant.grossAnnualIncome
                        }
                      />
                      <KeyValue title={'Net Worth'} description={applicant.netWorth} />
                      <KeyValue
                        title={'Net Worth Date'}
                        description={formatShortDate(applicant.netWorthDate)}
                      />
                      <KeyValue
                        title={'Politically Exposed Person (PEP) Status'}
                        description={applicant.politicallyExposedPersonStatus}
                      />
                      <KeyValue title={'CKYC Number'} description={applicant.ckycNo} />
                      <KeyValue
                        title={'Demat Account Details (for allotment of units)'}
                        description={DLCLMasters[applicant.dlclId || '']}
                      />
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={
                            isCDSL(applicant.dlclId || '') &&
                            !checkValidationBasedOnDate(createdAt, dlclIdFieldValidationDate)
                              ? 'DPCL ID'
                              : 'DP ID'
                          }
                          description={applicant.dpId}
                        />
                      )}
                      {getclIdField(applicant.dlclId || '', createdAt) && (
                        <KeyValue title={'CL ID'} description={applicant.clId} />
                      )}
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={'Name of Broker/Depository Participant (DP)'}
                          description={
                            brokerList?.broker_list.find(
                              (broker) => broker.key === applicant.nameOfBroker
                            )?.value
                          }
                        />
                      )}
                    </Grid>
                  </Gridstyles>
                  {applicant.kraDeclaration && <TermsAndConditions />}
                  {applicant.applicantDecalaration && <ApplicantDeclaration />}
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
